import { createReducer, on } from '@ngrx/store';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { SmartCarsState } from './smart-car.models';
import * as smartCarActions from './smart-car.actions';

export const smartCarsInitialState: SmartCarsState = {
  smartCars: [],
  smartCarsPage: null,
  smartCarsPagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  loading: false,
  saving: false,
  disconnectingSmartCarId: null,
  error: null,
};

export const smartCarsReducer = createReducer(
  smartCarsInitialState,
  on(smartCarActions.loadSmartCarList, (state) => ({
    ...state,
    loading: true,
  })),
  on(smartCarActions.loadSmartCarListSuccess, (state, { smartCarsResponse }) => ({
    ...state,
    loading: false,
    smartCars: smartCarsResponse.result ?? [],
    smartCarsPage: {
      pageIndex: smartCarsResponse.pageIndex ?? 0,
      pageSize: smartCarsResponse.pageSize ?? 0,
      totalCount: smartCarsResponse.total ?? 0,
    },
  })),
  on(smartCarActions.loadSmartCarListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(smartCarActions.changePagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    smartCarsPagination: {
      pageIndex,
      pageSize,
    },
  })),
  on(smartCarActions.createSmartCar, smartCarActions.updateSmartCar, (state) => ({
    ...state,
    saving: true,
  })),
  on(smartCarActions.createSmartCarSuccess, smartCarActions.updateSmartCarSuccess, (state) => ({
    ...state,
    saving: false,
  })),
  on(smartCarActions.createSmartCarFailure, smartCarActions.updateSmartCarFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(smartCarActions.deleteSmartCar, (state) => ({
    ...state,
    loading: true,
  })),
  on(smartCarActions.deleteSmartCarSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(smartCarActions.deleteSmartCarFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  })),
  on(smartCarActions.disconnectSmartCar, (state, { smartCarId }) => ({
    ...state,
    disconnectingSmartCarId: smartCarId,
  })),
  on(smartCarActions.disconnectSmartCarSuccess, (state) => ({
    ...state,
    disconnectingSmartCarId: null,
  })),
  on(smartCarActions.disconnectSmartCarFailure, (state, { error }) => ({
    ...state,
    disconnectingSmartCarId: null,
    error: error.errorMessage ?? 'ERROR',
  }))
);
